// extracted by mini-css-extract-plugin
export var actionButton = "_cg-0";
export var attachmentLine = "_cg-1";
export var fileInput = "_cg-2";
export var fileUploadWrapper = "_cg-4";
export var footer = "_cg-3";
export var modalContent = "_cg-5";
export var paperclip = "_cg-6";
export var quillEditor = "_cg-7";